import { useMutation } from '@tanstack/react-query';
export interface HandlePhotoPayloadType {
  inferImagePayload: {
    image_uri: string;
    filename: string;
  };
}

const submitData = async (payload: { image_uri: string; filename: string }) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_APIM_BASE_URL}/waste-reports/v1/inference/image`,
      {
        method: 'POST',
        body: JSON.stringify({
          ...payload,
          // these are the default values and the fields are required for the API to work
          bin_bag_detector_threshold: 0.2,
          classification_confidence_threshold: 0.5,
        }),
        headers: {
          'Ocp-Apim-Subscription-Key': `${
            import.meta.env.VITE_APIM_API_KEY as string
          }`,
          'content-type': 'application/json',
        },
      },
    );
    return await response.json();
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const useInferImageData = () => {
  return useMutation({
    mutationFn: submitData,
  });
};
